<script>
import Layout from "@/router/layouts/main";
import { mapState } from "vuex";
import native from "@/native";
import Banners from "@/components/widgets/banners";
import MinhaJornada from "@/components/widgets/minha-jornada";
import DashboardResumo from "@/components/widgets/dashboard-resumo";

/**
 * Dashboard. Ordem: Banner -> Minha Jornada (brasão, qualificação, PIN) -> link de indicação ->
 * resumo (Adesões do mês da meta pessoal + Seus números no período do Ranking Nacional).
 * O card "Comunidade" e os KPIs de rede (Total/Novos Diretos, Total/Novos na Equipe) saíram
 * daqui a pedido do negócio; a Comunidade continua acessível pelo menu lateral (side-nav.vue).
 */
export default {
  locales: {
    pt: {
    },
    es: {
    }
  },
  components: {
    Layout,
    Banners,
    MinhaJornada,
    DashboardResumo,
  },
  computed: {
    ...mapState({
      account: state => state.account
    }),
    // Saudacao do topo: so o primeiro nome, para nao quebrar linha no celular.
    primeiroNome() {
      const nome = (this.account.user.name || "").trim().split(/\s+/)[0] || "";
      return nome ? nome.charAt(0).toUpperCase() + nome.slice(1).toLowerCase() : "";
    },
  },
  data() {
    return {
      referral: process.env.VUE_APP_URL_PAINEL + this.$store.state.account.user.indication,

      // Ponte com o container nativo. Fica no `data` (e nao importado direto no
      // template) para o template poder testar `native.isNative`.
      native: native,
    };
  },
  methods: {
    /**
     * Compartilha o link de indicacao pela folha nativa do sistema.
     *
     * Por que vale: o produto vive de indicacao, e a folha nativa abre TODOS os
     * aplicativos do aparelho de uma vez (WhatsApp, Telegram, SMS, e-mail) em
     * vez de so o WhatsApp. De quebra, e uso de API nativa — um dos argumentos
     * concretos contra a reprovacao pela regra 4.2 da Apple.
     *
     * Fora do aplicativo cai na Web Share API e, se nem ela existir, no
     * clipboard — por isso o botao so aparece quando ha para onde ir.
     */
    shareReferral() {
      this.native.haptic("light");

      this.native
        .share({
          title: "Sales Teams",
          text: "Cadastre-se pelo meu link de indicacao:",
          url: this.referral,
          dialogTitle: "Compartilhar link de indicacao",
        })
        .catch(() => {
          /* usuario fechou a folha de compartilhamento: caminho normal */
        });
    },
  },
};
</script>

<template>
  <Layout>
    <!-- Ancora da tela: o Dashboard era a unica tela sem titulo. -->
    <div class="page-title-box home-greeting">
      <h4>Olá{{ primeiroNome ? ", " + primeiroNome : "" }}</h4>
      <p class="page-title-desc">Acompanhe seus números e as novidades do mês.</p>
    </div>

    <Banners></Banners>

    <!-- Minha Jornada oculta temporariamente a pedido do usuário — remover o v-if para reativar -->
    <MinhaJornada v-if="false" />

    <div v-if="account.user.referral == 'active'" class="card home-referral">
      <div class="card-body d-flex align-items-center">
        <span class="home-referral-icon" aria-hidden="true">
          <i class="bx bx-link-alt"></i>
        </span>
        <template v-if="account.user.indication">
          <div class="home-referral-text">
            <h5 class="mb-0">Link de Indicação de Consultores</h5>
            <small class="text-muted">Compartilhe para receber novos consultores na sua rede.</small>
          </div>
          <div class="home-referral-actions">
            <!--
              Dentro do aplicativo, a folha de compartilhamento do sistema
              substitui o botao so-do-WhatsApp: ela abre todos os aplicativos do
              aparelho de uma vez.
            -->
            <button v-if="native.isNative" class="btn btn-ghost btn-icon" title="Compartilhar"
              aria-label="Compartilhar link de indicação" @click="shareReferral">
              <i class="bx bx-share-alt font-size-22" aria-hidden="true"></i>
            </button>
            <!-- Sem `title=` aqui: no ShareNetwork `:title` e o texto compartilhado. -->
            <ShareNetwork v-else network="whatsapp" url="" :title="referral" class="btn btn-ghost btn-icon"
              aria-label="Enviar link de indicação pelo WhatsApp">
              <i class="bx bxl-whatsapp font-size-22" aria-hidden="true"></i>
            </ShareNetwork>
            <button class="btn btn-ghost btn-icon" title="Copiar link" aria-label="Copiar link de indicação"
              v-clipboard:copy="referral" v-on:click="$noty.success('O link foi copiado!')">
              <i class="bx bx-copy font-size-20" aria-hidden="true"></i>
            </button>
          </div>
        </template>
        <template v-else>
          <div class="home-referral-text">
            <h5 class="mb-0">Link de Indicação de Consultores</h5>
            <router-link tag="a" to="/account/indication">
              Você ainda não possui um link de indicação, <u>clique aqui</u> para criar.
            </router-link>
          </div>
        </template>
      </div>
    </div>

    <DashboardResumo />
  </Layout>
</template>

<style scoped>
.home-greeting {
  padding-bottom: 1rem;
}

.home-referral .card-body {
  gap: 0.85rem;
  padding-top: 0.85rem;
  padding-bottom: 0.85rem;
}

/* Chip do icone: quadrado tonalizado na cor da marca. */
.home-referral-icon {
  display: inline-flex;
  flex: 0 0 auto;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  border-radius: var(--st-radius);
  background: var(--st-brand-soft);
  color: var(--st-brand);
  font-size: 1.35rem;
}

.home-referral-text {
  min-width: 0;
  flex: 1 1 auto;
}

.home-referral-actions {
  display: flex;
  flex: 0 0 auto;
  gap: 0.25rem;
}
</style>
